import { callBackend } from "./callBackend";

/**
 * Validates and applies a promotional coupon code against the current booking.
 *
 * @param {Object} params
 * @param {string} params.couponCode - The promo code to check (e.g. "WELCOME10")
 * @param {number} params.totalAmount - Total booking amount before coupon
 * @param {string} [params.roomType] - Room type identifier (e.g. "standardAC")
 * @param {number} [params.roomCount=1] - Number of rooms selected
 * @param {number} [params.nights=1] - Number of nights for the stay
 * @param {string} [params.phone] - User phone number for usage limit validation
 * @param {string} [params.email] - User email for usage limit validation
 * @returns {Promise<Object>} Coupon result containing discountAmount, message, finalAmount, etc.
 */
export async function checkAndApplyCoupon({
  couponCode,
  totalAmount,
  roomType,
  roomCount = 1,
  nights = 1,
  phone,
  email,
  checkinDate,
  checkoutDate,
}) {
  const payload = {
    action: "checkAndApplyCoupon",
    couponCode: couponCode ? couponCode.trim().toUpperCase() : "",
    totalAmount: Number(totalAmount) || 0,
    roomType,
    roomCount: Math.max(1, Number(roomCount) || 1),
    nights: Math.max(1, Number(nights) || 1),
    phone,
    email,
    checkinDate,
    checkoutDate,
  };

  return await callBackend("backendBookingService", "checkAndApplyCoupon", payload);
}

/**
 * Fetch available promotional coupons (e.g. for display on website promo banners)
 */
export async function fetchCoupons() {
  return await callBackend("backendBookingService", "listCoupons", {});
}
